const getBaseUrl = (version = '1') => {
  if (process.env.REACT_APP_USE_DEVELOPMENT_BASE_URL === 'true') {
    return `${window.location.origin}/${version}/`;
  } else if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    if (process.env.REACT_APP_USE_LOCAL === 'true') {
      return `${process.env.REACT_APP_API_URL_LOCAL}/${version}/`;
    } else {
      // return `https://72.209.194.105:8010/${version}/`;
      return `https://devoo.edlen.com/${version}/`;
    }
  } else {
    return `${window.location.origin}/${version}/`;
  }
};

export default getBaseUrl;
